export default "__VITE_ASSET__ILMU2W1g__"